<template>
  <svg aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <circle fill="#63CC98" cx="300" cy="1000" r="20"></circle>
    <circle fill="#63CC98" cx="220" cy="1000" r="20"></circle>
    <circle fill="#63CC98" cx="980" cy="1000" r="20"></circle>
    <circle fill="#63CC98" cx="900" cy="1000" r="20"></circle>
    <path
      fill="#7DB9D8"
      d="M600,500A100.1127,100.1127,0,0,0,500,600a20,20,0,0,0,40,0,60,60,0,0,1,120,0,20,20,0,0,0,40,0A100.1127,100.1127,0,0,0,600,500Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M800,980H697.9978A100.1011,100.1011,0,0,0,620,902.0249V622.355a30,30,0,1,0-40,0v279.67A100.1011,100.1011,0,0,0,502.0022,980H400a20,20,0,0,0,0,40H502.0022a100.0223,100.0223,0,0,0,195.9956,0H800a20,20,0,0,0,0-40Zm-200,80a60,60,0,1,1,60-60A60.068,60.068,0,0,1,600,1060Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M900,300H620A100.1127,100.1127,0,0,0,520,200H300A100.1127,100.1127,0,0,0,200,300V700A100.1127,100.1127,0,0,0,300,800H540V760H379.95A99.48,99.48,0,0,0,400,700V400a60.0681,60.0681,0,0,1,60-60H900a60.0681,60.0681,0,0,1,60,60V700a60.0681,60.0681,0,0,1-60,60H660v40H900a100.1127,100.1127,0,0,0,100-100V400A100.1127,100.1127,0,0,0,900,300Zm-440,0A100.1127,100.1127,0,0,0,360,400V700a60,60,0,0,1-120,0V300a60.0681,60.0681,0,0,1,60-60H520a60.0681,60.0681,0,0,1,60,60Z"
    ></path>
  </svg>
</template>
